export const ALLOW_UNSUPPORTED_BROWSER_COOKIE_KEY = 'allowUnsupportedBrowser';

export enum SupportedBrowser {
    Chrome = 'Chrome',
    Edge = 'Edge',
    Firefox = 'Firefox',
    Safari = 'Safari',
    Yandex = 'Yandex',
}

export const supportedBrowsersVersionsList: Record<SupportedBrowser, number> = {
    [SupportedBrowser.Chrome]: 140,
    [SupportedBrowser.Edge]: 139,
    [SupportedBrowser.Firefox]: 128,
    [SupportedBrowser.Safari]: 18,
    [SupportedBrowser.Yandex]: 25,
};

export const browserList: {
    browser: SupportedBrowser;
    url: string;
}[] = [
    { browser: SupportedBrowser.Chrome, url: 'https://www.google.com/chrome/' },
    {
        browser: SupportedBrowser.Firefox,
        url: 'https://www.firefox.com/browsers/enterprise/',
    },
    { browser: SupportedBrowser.Safari, url: 'https://www.apple.com/safari/' },
    {
        browser: SupportedBrowser.Edge,
        url: 'https://www.microsoft.com/en-us/edge',
    },
    {
        browser: SupportedBrowser.Yandex,
        url: 'https://browser.yandex.ru/',
    },
];
